document.addEventListener("readystatechange", linkAllDynamicSliders);
document.addEventListener("DOMContentLoaded", linkAllDynamicSliders);
linkAllDynamicSliders();

function linkAllDynamicSliders() {
    document.querySelectorAll(".dynamic-slider").forEach(dynamicSlider => {
        linkDynamicSlider(dynamicSlider);
    });
}


/**
 *
 * Crea todos los elementos visuales y los eventos de JS para el slider dinámico
 *  
 * @param {HTMLElement} dynamicSlider Elemento de HTML que será el slider
 *  
 */
function linkDynamicSlider(dynamicSlider) {
    if (dynamicSlider.linked === true) return true; 
    dynamicSlider.linked = true;
    

    let dynamicSliderWrapper = document.createElement("div");
        if (dynamicSlider.classList.contains("dynamic-slider-sm")) {
            dynamicSliderWrapper.classList.add("dynamic-slider-sm");
            dynamicSlider.classList.remove("dynamic-slider-sm")
        }
        dynamicSliderWrapper.classList.add("dynamic-slider-wrapper");
    dynamicSlider.parentElement.insertBefore(dynamicSliderWrapper, dynamicSlider);
    dynamicSlider.remove();
    dynamicSlider.left = "0px";
    
    dynamicSliderWrapper.appendChild(dynamicSlider);
    let scrollbarDiv = document.createElement("div");
        scrollbarDiv.classList.add("dynamic-slider-scrollbar-div");
        let scrollBarPosition = document.createElement("div");
            scrollBarPosition.classList.add("scrollbar-position");
        scrollbarDiv.appendChild(scrollBarPosition);
    dynamicSliderWrapper.appendChild(scrollbarDiv);

    if (dynamicSlider.classList.contains("no-scroll-bar")) {
        scrollbarDiv.style.display = "none";
    }
    
    let controlsWrapper = document.createElement("div");
        controlsWrapper.classList.add("controls-wrapper");
        controlsWrapper.innerHTML = `
            <div class="control-left">
                <img class="controls-image" src="https://cdn.shopify.com/s/files/1/0059/7436/0127/files/control-left.png?v=1691676294">
            </div>
            <div class="control-right">
                <img class="controls-image" src="https://cdn.shopify.com/s/files/1/0059/7436/0127/files/control-right.png?v=1691676294">
            </div>
        `;
    dynamicSliderWrapper.appendChild(controlsWrapper);

    if (dynamicSlider.classList.contains("no-controls")) {
        controlsWrapper.remove();
    }
    

    var moveScrollBar      = false;
    var disableClickToMove = false;
    var startX             = undefined;
    var scrollBarStartX    = undefined;
    var maximumScroll      = undefined;
    var visibleWidth       = undefined;
    var realWidth          = undefined;

    let updateSlider = () => {
        let paddingLeft = window.getComputedStyle(dynamicSlider, null).getPropertyValue('padding-left');
        let paddingRight = window.getComputedStyle(dynamicSlider, null).getPropertyValue('padding-right');
            scrollbarDiv.style.marginLeft = paddingLeft;
            scrollbarDiv.style.marginRight = paddingRight;
            scrollbarDiv.style.width = `calc(100% - ${paddingLeft} - ${paddingRight})`;
        
        visibleWidth  = dynamicSlider.offsetWidth;
        realWidth     = dynamicSlider.scrollWidth;
        maximumScroll = realWidth - visibleWidth;
        
        if (realWidth <= visibleWidth) {
            dynamicSliderWrapper.classList.add("all-elements-visible");
        } else {
            dynamicSliderWrapper.classList.remove("all-elements-visible");
        }
        checkControls();
    }
    let updateSliderToSliderScroll = () => {
        updateSlider();
        let currentScroll = dynamicSlider.scrollLeft;
        let scrolledPercentaje = currentScroll / maximumScroll;
        scrollBarPosition.style.width = `${visibleWidth * 100 / realWidth}%`;
        scrollBarPosition.style.left  = `${calculateScrollbarLeft(scrolledPercentaje)}%`;
    }

    let updateSliderToScrollbarScroll = () => {
        updateSlider();
        // revert linear interpolation (lerp) formula: 
        let scrollBarPositionLeft = parseFloat(window.getComputedStyle(scrollBarPosition, null).getPropertyValue('left'))        
        let scrolledPercentaje = scrollBarPositionLeft / getScrollBarWidth();
        let sliderScroll = scrolledPercentaje * realWidth;
        dynamicSlider.scrollLeft = sliderScroll;
    };

    let moveToMouse = (e) => {
        if (e.target !== scrollbarDiv || disableClickToMove === true) return;
        let boundingClient = scrollbarDiv.getBoundingClientRect();
        let position = (e.clientX - boundingClient.left) - (parseFloat(window.getComputedStyle(scrollBarPosition, null).getPropertyValue('width')) / 2);
        let newLeft = `max(0px, min(${calculateScrollbarLeft(1)}%, ${position}px))`;
        scrollBarPosition.style.left = newLeft;
        updateSliderToScrollbarScroll();
    }

    let calculateScrollbarLeft = (scrolledPercentaje) => {
        // linear interpolation (lerp) formula:
            //  Maximum %                // Minumum
        return (1 - scrolledPercentaje) * 0 + scrolledPercentaje * getScrollBarPositionPercentaje();
    }

    let getScrollBarWidth = () => {
        let paddingLeft  = parseFloat(window.getComputedStyle(scrollbarDiv, null).getPropertyValue('padding-left'));
        let paddingRight = parseFloat(window.getComputedStyle(scrollbarDiv, null).getPropertyValue('padding-right'));
        let maxWidthInPx = parseFloat(window.getComputedStyle(scrollbarDiv, null).getPropertyValue('width')) - paddingRight - paddingLeft;
        return maxWidthInPx;
    }
    let getScrollBarPositionPercentaje = () => {
        let widthInPx = parseFloat(window.getComputedStyle(scrollBarPosition, null).getPropertyValue('width'));
        return 100 - parseFloat(widthInPx * 100 / getScrollBarWidth());
    }
    
    let enableMovement = (e) => {
        startX = e.clientX;
        disableClickToMove = true;
        moveScrollBar = true;
        let scrollBarPositionLeft = window.getComputedStyle(scrollBarPosition, null).getPropertyValue('left');
        scrollBarStartX = scrollBarPositionLeft;
    };
    let disableMovement = (e) => {
        moveScrollBar = false;
        startX          = undefined
        scrollBarStartX = undefined
        setTimeout(() => {
            disableClickToMove = false
        }, 1000);
    };
    let mouseMovementThroughScrollBar = (e) => {
        if ( moveScrollBar !== true || startX === undefined || scrollBarStartX === undefined) return;
        let relativeX = e.clientX - startX;
        let newLeft = `max(0px, min(${calculateScrollbarLeft(1)}%, calc(${scrollBarStartX} + ${relativeX}px)))`;
        scrollBarPosition.style.left = newLeft;
        updateSliderToScrollbarScroll();
    }

    let controlRight = controlsWrapper.querySelector(".control-right");
    let controlLeft = controlsWrapper.querySelector(".control-left");
    let checkControls = () => {
        if (dynamicSlider.scrollLeft <= 0) {
            controlLeft.style.display = "none";
        } else {
            controlLeft.style.display = "flex";
        }
        
        
        if (dynamicSlider.scrollLeft >= maximumScroll) {
            controlRight.style.display = "none";
        } else {
            controlRight.style.display = "flex";
        }
    }
    let moveSlider = (direction) => {
        if (direction !== -1 && direction !== 1) {
            return console.warn("Only -1 and 1 values allowed!");
        }

        let finalScroll = Math.max(0, Math.min(maximumScroll, dynamicSlider.scrollLeft + (visibleWidth * direction)));

        let lastFrameTime = 0;
        const frameDuration = 1000 / 60; // 60 FPS. Adjust as needed.
        let animationFrameId = null;

        function loop(currentTime) {
            animationFrameId = requestAnimationFrame(loop);

            const deltaTime = currentTime - lastFrameTime;

            if (deltaTime < frameDuration) return;

            dynamicSlider.scrollLeft += deltaTime * direction;

            var isMaterial   = document.getElementById('dinamic-slider-material');
            var isTecnologia = document.getElementById('dinamic-slider-tecnologia');

            if (isMaterial != null) {
                if (direction === -1 && dynamicSlider.scrollLeft <= (finalScroll + 26.9)) {
                    stopLoop();
                } 
                if (direction === 1 && dynamicSlider.scrollLeft >= (finalScroll - 26.9)) {
                    stopLoop();
                } 
            }
            else if (isTecnologia != null) {
                if (direction === -1 && dynamicSlider.scrollLeft <= finalScroll) {
                    stopLoop();
                } 
                if (direction === 1 && dynamicSlider.scrollLeft >= finalScroll) {
                    stopLoop();
                } 
            } else {
                if (direction === -1 && dynamicSlider.scrollLeft <= finalScroll) {
                    stopLoop();
                } 
                if (direction === 1 && dynamicSlider.scrollLeft >= finalScroll) {
                    stopLoop();
                } 
            }

            lastFrameTime = currentTime - (deltaTime % frameDuration);
        }

        function startLoop() {
            if (!animationFrameId) {
                lastFrameTime = performance.now();
                animationFrameId = requestAnimationFrame(loop);
            }
        }

        function stopLoop() {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = null;
            }
        }
        startLoop();
        
    }

    controlRight.addEventListener("click", () => {
        moveSlider(1);
    });
    controlLeft.addEventListener("click", () => {
        moveSlider(-1);
    });
    
    updateSliderToSliderScroll();
    dynamicSlider.addEventListener("scroll", updateSliderToSliderScroll);
    window.addEventListener("resize", updateSliderToSliderScroll);
    scrollBarPosition.addEventListener("mousedown", enableMovement);
    scrollbarDiv.addEventListener("click", moveToMouse)
    document.addEventListener("mouseup", disableMovement);
    window.addEventListener("mouseleave", disableMovement);
    document.addEventListener("mouseleave", disableMovement);
    window.addEventListener("mousemove", mouseMovementThroughScrollBar);

}